module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr14-f7e5271b93466fd73dab43a81d90f188.jpg";